<template>
  <div>
    <slot name="label">
      <template v-if="label">
        <label>{{label}}</label>
        <br>
      </template>
    </slot>
    <el-select class="select-default max-step-width client-autocomplete"
               remote
               :allow-create="allowCreate"
               :loading="loading"
               :placeholder="$t('generic.searchOrCreate')"
               :remote-method="onRemoteMethod"
               :value="value"
               clearable
               filterable
               multiple
               allow-create=""
               default-first-option
               @change="onChange"
               v-bind="$attrs"
               value-key="name">
      <el-option v-for="user in users.data"
                 class="select-default"
                 :key="user.id"
                 :label="user.name"
                 :value="user.email">
        <div class="d-flex align-items-center">
          <span>{{user.email}}</span>
        </div>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import throttle from 'lodash/throttle'
  import ClientUserService from 'src/services/ClientUserService'

  export default {
    name: 'email-autocomplete',
    inheritAttrs: false,
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      value: {
        type: Array,
        default: () => []
      },
      searchParams: {
        type: Object,
        default: () => ({})
      },
      label: {
        type: String
      },
      allowCreate: {
        type: Boolean,
        default: true
      }
    },
    model: {
      prop: 'value',
      event: 'change'
    },
    data () {
      return {
        loading: false,
        users: {
          data: []
        }
      }
    },
    methods: {
      async searchUsers (query) {
        try {
          this.loading = true
          this.users = await ClientUserService.get({query, limit: 50, ...this.searchParams})
        } catch (e) {
          console.warn(e)
        } finally {
          this.loading = false
        }
      },
      onChange (val) {
        if (!val) {
          this.onRemoteMethod(val)
        }
        let model = val
        if (typeof val === 'string') {
          model = {
            name: val
          }
        }
        this.$emit('change', model)
      }
    },
    created () {
      this.onRemoteMethod = throttle(this.searchUsers, 200)
    },
    async mounted () {
      let name = this.client ? this.client.name : ''
      await this.searchUsers(name)
      if (name) {
        let model = this.users.data.find(c => c.name === this.client.name)
        if (model) {
          this.onChange(model)
        }
      }
    }
  }
</script>
<style lang="scss">
  .option-image {
    width: 50px;
    height: auto;
    max-height: 50px;
  }

  .client-autocomplete {
    &.max-step-width {
      width: 100%;
      max-width: 100%;
    }
  }
</style>
